import styled from "styled-components";
import colors from "../../constants/colors";

export const Wrapper = styled("div")({
  display: "flex",
  justifyContent: "center",
  width: "100%",
  minHeight: "100vh",
  background: colors.GRADIENT_BACKGROUND,
});

export const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  background: colors.GLASS_WHITE,
  backdropFilter: "blur(20px) saturate(180%)",
  WebkitBackdropFilter: "blur(20px) saturate(180%)",
  border: `1px solid ${colors.GLASS_BORDER}`,
  boxShadow: `0 8px 32px 0 ${colors.SHADOW_LIGHT}`,
  width: "100%",
  maxWidth: "450px",
  margin: "0 auto",
  minHeight: "100vh",

  "@media (min-width: 768px)": {
    maxWidth: "720px",
    borderRadius: "20px",
    margin: "24px auto",
    minHeight: "calc(100vh - 48px)",
    boxShadow: `0 8px 32px 0 ${colors.SHADOW_MEDIUM}`,
  },

  "@media (min-width: 1024px)": {
    maxWidth: "960px",
  },
});

export const ImageWrapper = styled("div")({
  width: "100%",
  marginBlock: "1rem",
  padding: "0 1.5rem",
  img: {
    width: "100%",
    borderRadius: "10px",
    border: `1px solid ${colors.GREY_2}`,
  },
});
